import PushDiaporama from './pushDiaporama'

const pushDiaporama = new PushDiaporama()
pushDiaporama.init()
